import React from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Select, FormHelperText, Typography, Divider, TextField } from '@mui/material';
import { FormikProps } from 'formik';
import { BusinessType } from '../../../types/client';

// Define a simplified FormValues interface for this component
interface FormValues {
  businessType: BusinessType;
  [key: string]: any; // Allow other fields that might be accessed
}

interface Props {
  formik: FormikProps<FormValues>;
  businessTypes: readonly string[];
  isEditing?: boolean; // Flag to determine if we're in edit mode
}

/**
 * BusinessInformationSection component
 * Displays business type as a dropdown in AddClientDialog
 * Displays business type as a read-only field in EditClientDialog
 */
const BusinessInformationSection: React.FC<Props> = ({ formik, businessTypes, isEditing = false }) => {
  console.log('BusinessInformationSection render with isEditing:', isEditing);
  
  // Render the section header
  const renderHeader = () => (
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom>Business Information</Typography>
      <Divider sx={{ mb: 2 }} />
    </Grid>
  );
  
  // Render read-only business type field for edit mode
  const renderReadOnlyField = () => (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <TextField
          label="Business Type"
          value={formik.values.businessType}
          InputProps={{
            readOnly: true,
          }}
          disabled
          variant="outlined"
          helperText="Business type cannot be changed after creation"
        />
      </FormControl>
    </Grid>
  );
  
  // Render editable dropdown for add mode
  const renderEditableField = () => (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel id="business-type-label">Business Type</InputLabel>
        <Select
          labelId="business-type-label"
          id="businessType"
          name="businessType"
          value={formik.values.businessType}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.businessType && Boolean(formik.errors.businessType)}
          label="Business Type"
        >
          {businessTypes.map((type) => (
            <MenuItem key={type} value={type}>{type}</MenuItem>
          ))}
        </Select>
        {formik.touched.businessType && formik.errors.businessType && (
          <FormHelperText error>{formik.errors.businessType}</FormHelperText>
        )}
      </FormControl>
    </Grid>
  );
  
  return (
    <>
      {renderHeader()}
      {isEditing ? renderReadOnlyField() : renderEditableField()}
    </>
  );
};

export default BusinessInformationSection;
